/**
 *
 * Tenant Announcement Page actions
 *
 */

import {EXECUTE_EDIT_ACTION, EXECUTE_VIEW_ACTION, HANDLE_PARAMS_ACTION} from './constants';


export const executeEditAction = (id) => ({
    type: EXECUTE_EDIT_ACTION,
    payload: {id},
});

export const executeViewAction = (id) => ({
    type: EXECUTE_VIEW_ACTION,
    payload: {id},
});

export function handleParams(id) {
    return {
        type: HANDLE_PARAMS_ACTION,
        payload: {id},
    };
}